module.exports = __webpack_public_path__ + "img/f40e820.png";